module.exports = __webpack_public_path__ + "static/nbcLogo-9a155a8c5e8c2d06e857e2b0e66a185e.png";